import styled, { css } from "styled-components";
import theme from "../../shared/theme";
import { Col } from "react-bootstrap";


export const ColCentered = styled(Col)`
  display: flex;
  justify-content: center;
`
export const ColSpaced = styled(Col)`
  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
    margin-bottom: 1px;
  }
`

export const TextBox = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

export const Section = styled.div`
  padding-top: 3rem;
  padding-bottom: 3rem;
`;

export const ContentBox = styled.div`
  width: 100%;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,.15);
  padding-top: 7em;
  padding-bottom: 30px;
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  margin-top: 1em;
  color: #1b3647;
  text-align: center;
  font-weight: bold;
  @media screen and (max-width: 576px) {
    font-size: 7vw;
  }
`;

export const SubTitle = styled(Title)`
  font-size: 1em!important;
  margin-bottom: 2em;
`;

export const ColumnInput = styled.div`
  display: flex;
  align-items: baseline;
  flex-flow: column;
`;

export const Input = styled.input`
  -webkit-box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
  box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #33393d;
  color: #363636;
`;

export const InputLabel = styled.label`
  color: #363636;
  display: block;
  font-size: 1rem;
  font-weight: 700;
`;

export const BoxSchoolName = styled.div`
  background-color: #ceff00;
  padding: 3rem 1.5rem;
  min-height: 183px;
  h1 {
    color: #363636;
    font-weight: 600;
    line-height: 1.125;
  }
  h2 {
    font-size: 14px;
  }
`;

export const Radio = styled.label`
  cursor: pointer;
  color: ${theme.colors.defaultLabel};
  font-weight: bold;
  font-size: ${theme.font.fontSizeDefault};
  ${props => props.isError && `color: ${theme.colors.error}`}
  font-family: Open Sans,sans-serif!important;
`;

export const BoxActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 10px;
`;

export const BoxInputs = styled(BoxActions)`
  justify-content: center;
  flex-flow: column;
  width: 100%;
  margin-top: 50px;
  div {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const ButtoPayment = styled.button`
  border: 1px solid #1b3647;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "#1b3647"};
  border-radius: 8px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.375em - 1px) calc(0.625em - 1px);
  position: relative;
  vertical-align: top;
  width: ${props => (props.width ? props.width : "400px")};
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
    flex-flow: column;
  }
  color: #1b3647;
  p {
    color: ${props => (props.pcolor ? props.pcolor : "#fff")};
    letter-spacing: 1.5px;
    font-weight: 700;
    font-family: Open Sans;
    text-transform: uppercase;
    margin-bottom: 0px;
  }
  transition: background-color 200ms linear;
  hr {
    margin-top: 40px;
  }
`;

export const ButtoDownload = styled(ButtoPayment)`
  height: 2.25em;
  text-align: center;
  p {
    line-height: 30px;
    font-size: 1rem;
    font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Open Sans, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
`;

export const BodyCardAtheletes = styled.div`
  width: 100%;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.12);
  -webkit-margin-after: 1em;
  margin-block-end: 1em;
  padding: 0;
  height: 90px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 50px;
`;

export const ParticipantName = styled.span`
  font-weight: 700;
  margin: 0;
  color: #1b3647;
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  white-space: nowrap;
`;

export const BlackLine = styled.hr`
  background-color: #203a4b
`

export const DivInfos = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${props =>
    props.justify ? props.justify : "space-between"};
  align-items: center;
  height: 100%;
`;

export const Label = styled.label`
  color: ${theme.colors.defaultLabel};
  font-weight: bold;
  font-size: ${theme.font.fontSizeDefault};
  ${props => props.isError && `color: ${theme.colors.error}`}
  font-family: Open Sans,sans-serif!important;
`;

export const InputNaoSouParceiro = styled.input``;
